/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Delete_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "It will stop starting runs. This cannot be undone." |
*
* @param {Agent_Triggers_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_delete_confirm_description = /** @type {((inputs?: Agent_Triggers_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Delete_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Auslöser startet dann keine Läufe mehr. Dies kann nicht rückgängig gemacht werden.")
	return /** @type {LocalizedString} */ ("It will stop starting runs. This cannot be undone.")
});